import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import Stack from "@mui/material/Stack";
import AudioPlayer from "../../AudioPlayer";
import TextField from "@mui/material/TextField";

import { API_DOMAIN } from "../../../constants";
//const API_DOMAIN = "https://capacitamos.com/online"

const Writing = ({ question, setAnswer, courseCode }) => {

  const validate = (value) => {
    if (value.toUpperCase().trim() === question.frase.trim()) {
      setAnswer(question.id + "-1");
    } else {
      setAnswer(question.id + "-0");
    }
  };

  if (!question) return null;

  return (
    <Grid container columns={{ xs: 4, md: 12 }}>
      <Grid container spacing={2}>
        
        {/* Audio + Imagen responsivo */}
        <Grid item xs={12}>
          <Grid container spacing={2} alignItems="center">

            {/* AUDIO — 12 en móvil, 4 en desktop */}
            <Grid item xs={12} md={4}>
              <Stack direction="row" justifyContent="center">
                <AudioPlayer
                  audioUrl={`${API_DOMAIN}/contents/cursos/${courseCode}/audios/${question.audio}`}
                  key={question.audio}
                />
              </Stack>
            </Grid>

            {/* IMAGEN — 12 en móvil, 8 en desktop */}
            <Grid item xs={12} md={8}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CardMedia
                  component="img"
                  sx={{
                    width: "100%",
                    height: "auto",
                    maxWidth: 350,
                    objectFit: "contain",
                    borderRadius: 2,
                  }}
                  image={`${API_DOMAIN}/contents/cursos/${courseCode}/img/${question.imagen}`}
                  loading="lazy"
                />
              </Box>
            </Grid>

          </Grid>
        </Grid>

        {/* INPUT */}
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              my: 2,
            }}
          >
            <TextField
              autoComplete="off"
              id="standard-basic"
              variant="outlined"
              sx={{ width: "90%" }}
              onChange={(event) => validate(event.target.value)}
            />
          </Box>
        </Grid>

      </Grid>
    </Grid>
  );
};

export default Writing;
